module.exports = __webpack_public_path__ + "img/diqvzhuyebanner.8c382a97.png";